<script setup lang="ts">
interface Props {
  width?: string;
  height?: string;
  variant?: 'text' | 'circular' | 'rectangular';
  animation?: 'pulse' | 'wave' | false;
}

withDefaults(defineProps<Props>(), {
  width: '100%',
  height: '1rem',
  variant: 'text',
  animation: 'pulse',
});
</script>

<template>
  <div
    :class="[
      'app-skeleton',
      {
        'app-skeleton--text': variant === 'text',
        'app-skeleton--circular': variant === 'circular',
        'app-skeleton--rectangular': variant === 'rectangular',
        'app-skeleton--pulse': animation === 'pulse',
        'app-skeleton--wave': animation === 'wave',
      },
    ]"
    :style="{
      width: width,
      height: height,
    }"
  />
</template>

<style scoped>
@reference "../../../tailwind.css";

@layer components {
  .app-skeleton {
    @apply inline-block;
    background-color: var(--surface-strong);
    overflow: hidden;
    position: relative;
  }

  .app-skeleton--text {
    @apply rounded;
    transform: scale(1, 0.6);
  }

  .app-skeleton--circular {
    @apply rounded-full;
  }

  .app-skeleton--rectangular {
    @apply rounded-lg;
  }

  .app-skeleton--pulse {
    animation: skeleton-pulse 1.5s ease-in-out infinite;
  }

  .app-skeleton--wave::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      color-mix(in srgb, var(--text-primary) 5%, transparent),
      transparent
    );
    animation: skeleton-wave 1.5s ease-in-out infinite;
  }

  @keyframes skeleton-pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes skeleton-wave {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
